module.exports = __webpack_public_path__ + "static/media/procedimentos-icon.90883342.svg";